import React from "react";
import CustomModalLayoutV2 from "./components/CustomModalLayoutV2";
import { Button } from "../../../../shadcn/components/ui/button";
interface AnnouncementEventModalProps {
  data: any;
  setAnnouncementModals: any;
  index: number;
}

export default function AnnouncementEventModalV2({
  data,
  setAnnouncementModals,
  index,
}: AnnouncementEventModalProps) {
  return (
    <CustomModalLayoutV2
      open={data[index]?.openModal}
      blurBackground={index === 0}
      onClose={() => {
        setAnnouncementModals((prev: any) =>
          prev.filter((_: any, i: number) => i !== index)
        );
      }}
      childrenClassName="px-4 lg:px-24 py-8 lg:py-10"
      className="pt-4 lg:pb-[30px] w-full mx-4 max-w-[650px]"
    >
      <div className="flex justify-center px-4 ">
        <div className="text-xs lg:text-sm font-openSans text-brand-textBlack max-w-[450px] flex flex-col justify-center items-center text-center gap-4 lg:gap-y-6">
          <div className="text-xl">Auction has Announcement</div>
          <div className="">{data[index]?.data?.announcement}</div>
          <Button
            className="px-20"
            onClick={() => {
              setAnnouncementModals((prev: any) =>
                prev.filter((_: any, i: number) => i !== index)
              );
            }}
          >
            Got it
          </Button>
        </div>
      </div>
    </CustomModalLayoutV2>
  );
}
